<template>
  <div class="fd_body" v-if="body_show">
    <!-- 公用头部 -->
    <public-header></public-header>
    <div class="success_top">
      <div class="report_t">
        <h2>{{data.name}} 你好！</h2>
        <h2 style="padding: 0 1.2rem;margin-top: 0.4rem;">非常感谢你的信任，也谢谢你愿意跟我分享你在职业发展过程中遇到的问题和期待。</h2>
      </div>
      <div class="report_b">
        <h4>我们的谈话主要围绕 ：</h4>
        <p>{{data.talk}}</p>
      </div>
    </div>
    <div class="report_main">
      <h2>个人信息</h2>
      <h3>姓名：{{data.name}}&nbsp&nbsp&nbsp&nbsp性别：{{data.sex}}</h3>
      <h3>职业年龄：{{data.year}}年</h3>
      <h3>目标职位：{{data.jname}}</h3>
      <h3>最高学历：{{data.education}}</h3>
      <h3>辅导老师：{{data.tname}}</h3>
      <h3>辅导日期：{{data.evaluating_time}}</h3>
    </div>
    <div class="report_main">
      <h2>综合情况</h2>
      <p>{{data.colligate}}</p>
    </div>
    <div class="report_main">
      <h2>工作经历</h2>
      <table class="report_table" v-for="item in data.position">
        <tr class="tr_first">
          <th>{{item.position}}</th>
        </tr>
        <tr>
          <td class="report_td">主要职责</td>
          <td>{{item.responsibility}}</td>
        </tr>
        <tr>
          <td class="report_td">喜欢且擅长</td>
          <td>{{item.likes}}</td>
        </tr>
        <tr>
          <td class="report_td">成长与收获</td>
          <td>{{item.harvest}}</td>
        </tr>
        <tr>
          <td class="report_td">遇到的挑战</td>
          <td>{{item.challenge}}</td>
        </tr>
      </table>
    </div>
    <div class="report_main">
      <h2>目标职位说明书</h2>
      <img :src="data.w_position" class="report_img" @click="img_preview(1,data.w_position)" />
      <h5>*点击查看完整大图</h5>
    </div>
    <div class="report_main">
      <h2>测评结果</h2>
      <img v-for="(c_result,index) in data.c_result" :key="index" :src="c_result" class="report_img" @click="img_preview(2,index)" />
      <h5>*点击查看完整大图</h5>
    </div>
    <div class="report_main">
      <h2>能力现状</h2>
      <table class="report_table">
        <tr>
          <th>1</th>
        </tr>
        <tr>
          <td class="report_td">突出能力</td>
          <td>{{data.protruding_ability}}</td>
        </tr>
        <tr>
          <td class="report_td">不足能力</td>
          <td>{{data.inability}}</td>
        </tr>
        <tr>
          <td class="report_td">建议</td>
          <td>{{data.suggest}}</td>
        </tr>
      </table>
    </div>
    <div class="report_main">
      <h2>竞争力分析</h2>
      <table class="report_table">
        <tr>
          <th>2</th>
        </tr>
        <tr>
          <td class="report_td">优势</td>
          <td>{{data.advantage}}</td>
        </tr>
        <tr>
          <td class="report_td">劣势</td>
          <td>{{data.inferiority}}</td>
        </tr>
        <tr>
          <td class="report_td">竞争策略</td>
          <td>{{data.competitive_strategy}}</td>
        </tr>
      </table>
    </div>
    <div class="report_main">
      <h2>行动建议</h2>
      <table class="report_table">
        <tr>
          <th>3</th>
        </tr>
        <tr>
          <td class="report_td">行动</td>
          <td>{{data.action}}</td>
        </tr>
        <tr>
          <td class="report_td">时间</td>
          <td>{{data.times}}</td>
        </tr>
        <tr>
          <td class="report_td">达成目标</td>
          <td>{{data.target}}</td>
        </tr>
        <tr>
          <td class="report_td">可能的挑战</td>
          <td>{{data.possible_challenges}}</td>
        </tr>
        <tr>
          <td class="report_td">资源支持</td>
          <td>{{data.resource_support}}</td>
        </tr>
      </table>
    </div>
    <div class="report_main">
      <h2>总结与寄语</h2>
      <p>{{data.summary}}</p>
    </div>
    <router-link :to="{path:'student_evaluation',query:{'teacherid':data.teacherid,'pay':pay}}" class="md_href" style="margin-top: 0.5rem;">给咨询师点评</router-link>
  </div>
</template>
<script>
import {
  ImagePreview
} from 'vant'
import {
  getreport
} from "@/api/totoring"
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        body_show: false,
        data: {},
        allImageList: [],
        pay: ""
      }
    },
    methods: {
      pullData() {
        this.pay = this.$route.query.pay;
        getreport({
            pay: this.$route.query.pay
          })
          .then((data) => {
            shareCon("totoring", this);
            this.body_show = true;
            this.data = data;
            this.allImageList.push(data.w_position);
          })
      },
      img_preview(num, idx) {
        ImagePreview({
          images: num == 1 ? this.allImageList : this.data.c_result,
          startPosition: idx,
          showIndex: false,
          onClose() {
            // do something
          }
        });
      },
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.fd_body {
  padding-bottom: 20px
}

.success_top {
  width: 100%;
  height: auto;
  background: linear-gradient(-90deg, rgba(235, 80, 50, 1) 0%, rgba(245, 127, 23, 1) 100%);
  text-align: center;
  padding: changeRem(.6)+px;
  .report_t {
    padding: 0 changeRem(.6)+px;
    text-align: left;
    h2 {
      color: #fff;
      font-size: changeRem(.52)+px;
      line-height: changeRem(.8)+px;
    }
  }
  .report_b {
    width: changeRem(13.8)+px;
    background: rgba(255, 255, 255, 1);
    border-radius: changeRem(.16)+px;
    padding: changeRem(.6)+px;
    text-align: justify;
    margin-top: changeRem(.4)+px;
    h4 {
      font-size: changeRem(.52)+px;
      color: #EB5032;
    }
    p {
      font-size: changeRem(.52)+px;
      color: #333;
      line-height: changeRem(.8)+px;
      margin-top: changeRem(.4)+px;
      padding: 0 changeRem(.6)+px;
    }
  }
}

.report_main {
  padding: changeRem(.6)+px;
  background: #fff;
  margin-top: changeRem(.4)+px;
  text-align: left;
  h2 {
    border-bottom: 2px solid #ccc;
    padding-bottom: changeRem(.4)+px;
    color: #333;
    font-size: changeRem(.68)+px;
  }
  h3 {
    color: #333;
    font-size: changeRem(.52)+px;
    margin-top: changeRem(.4)+px;
  }
  p {
    color: #333;
    font-size: changeRem(.52)+px;
    margin-top: changeRem(.4)+px;
    line-height: changeRem(.8)+px;
    text-align: justify;
  }
}

table.report_table {
  margin-top: changeRem(.6)+px;
  width: 100%;
  tr {
    border: 2px solid #ccc;
    border-top: none;
    th {
      line-height: changeRem(1.4)+px;
      text-align: left;
      padding: 0 changeRem(.6)+px;
      background: #EB5032;
      color: #fff;
      font-size: changeRem(.52)+px;
      border: 2px solid #EB5032;
    }
    td {
      padding: changeRem(.4)+px changeRem(.24)+px;
      line-height: changeRem(.72)+px;
      color: #333;
      font-size: changeRem(.48)+px;
      text-align: justify;
      width: 77%;
      display: inline-block;
      border-left: 2px solid #ccc;
    }
    .report_td {
      font-size: changeRem(.52)+px;
      width: 23%;
      text-align: center;
      border-left: none;
    }
  }
  .tr_first {
    border: none
  }
}

img.report_img {
  width: 100%;
  height: auto;
  vertical-align: middle;
  margin-top: changeRem(.6)+px;
}

h5 {
  color: #666;
  font-size: changeRem(.48)+px;
  margin-top: changeRem(.2)+px;
  text-align: right;
  width: 100%;
}
.md_href {
    display: block;
    width: changeRem(13.8)+px;
    height: changeRem(1.6)+px;
    background: rgba(235, 80, 50, 1);
    border-radius: changeRem(.16)+px;
    margin-top: changeRem(.5)+px;
    margin: 0 auto;
    line-height: changeRem(1.6)+px;
    color: #fff;
    font-size: 34px;
    text-align: center;
}
</style>
